import "./datacards.css";
import Chart from "react-apexcharts";
import { useState } from "react";
export default function Datacards(props) {
	const [options, setOptions] = useState(false);
	const handleOptions = () => {
		if (options === false) {
			setOptions(true);
			setOptions1(false);
			setOptions2(false);
			console.log(options);
		} else {
			setOptions(false);
		}
	};

	const [options1, setOptions1] = useState(false);
	const handleOptions1 = () => {
		if (options1 === false) {
			setOptions1(true);
			setOptions(false);
			setOptions2(false);
		} else {
			setOptions1(false);
		}
	};

	const [options2, setOptions2] = useState(false);
	const handleOptions2 = () => {
		if (options2 === false) {
			setOptions2(true);
			setOptions1(false);
			setOptions(false);
		} else {
			setOptions2(false);
		}
	};
	const bar = {
		options: {
			chart: {
				id: "basic-bar",
				height: 150,
				width: 330,
			},
			xaxis: {
				categories: [
					1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000,
				],
				labels: {
					show: false,
				},
				axisBorder: {
					show: false,
				},
				gridLines: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
				axisBorder: {
					show: false,
				},
				gridLines: {
					show: false,
					color: "#838383",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					colors: {
						ranges: [
							{
								from: 0,
								to: 100,
								color: "#fff",
							},
						],
					},
					columnWidth: "30%",
					barHeight: "80%",
				},
			},
			dataLabels: {
				enabled: false,
			},
			grid: {
				show: false,
				padding: {
					top: 0,
					bottom: 0,
				},
			},
		},
		series: [
			{
				name: "series-1",
				data: [30, 40, 45, 50, 49, 60, 70, 81, 87],
			},
		],
	};
	const area = {
		options: {
			colors: ["#FF4F79"],
			chart: {
				id: "basic-area",
				height: 180,
				width: 290,
			},
			xaxis: {
				categories: [
					1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000,
				],
				labels: {
					show: false,
				},
				axisBorder: {
					show: false,
				},
				gridLines: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
				axisBorder: {
					show: false,
				},
				gridLines: {
					show: false,
					color: "#FF4F79",
				},
			},
			plotOptions: {
				area: {
					colors: ["#FF4F79"],
				},
			},
			dataLabels: {
				enabled: false,
			},
			grid: {
				show: false,
				padding: {
					top: 0,
					bottom: 0,
				},
			},
		},
		series: [
			{
				name: "series-1",
				data: [30, 40, 45, 50, 49, 60, 70, 81, 87],
			},
		],
	};

	const area1 = {
		options: {
			colors: ["#FFBE0A"],
			chart: {
				id: "basic-area",
				height: 180,
				width: 290,
			},
			xaxis: {
				categories: [
					1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000,
				],
				labels: {
					show: false,
				},
				axisBorder: {
					show: false,
				},
				gridLines: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
				axisBorder: {
					show: false,
				},
				gridLines: {
					show: false,
					color: "#FF4F79",
				},
			},
			plotOptions: {
				area: {
					colors: ["#FF4F79"],
				},
			},
			dataLabels: {
				enabled: false,
			},
			grid: {
				show: false,
				padding: {
					top: 0,
					bottom: 0,
				},
			},
		},
		series: [
			{
				name: "series-1",
				data: [30, 47, 72, 25, 30, 58, 70, 81, 87],
			},
		],
	};

	const donut = {
		options: {
			labels: ["Remaining", "Used"],
			colors: ["#4169E1", "#E3E9FB"],
			plotOptions: {
				pie: {
					donut: {
						size: "70px",
						labels: {
							show: true,
							name: {
								show: false,
								fontSize: "90px",
								fontFamily: "Arial, sans-serif",
								color: "#888",
								fontWeight: "900",
								offsetY: 50,
								formatter: function () {
									"2,259";
								},
							},
							value: {
								show: true,
								fontSize: "40px",
								fontFamily: "Roboto, sans-serif",
								fontWeight: 600,
								color: props.mode ? "white" : "black",
								offsetY: 4,
								formatter: function () {
									return "2,258";
								},
							},
							total: {
								show: true,
								label: "",
								color: "#888",
								formatter: function () {
									return "2,258";
								},
							},
						},
					},
				},
			},
			dataLabels: {
				enabled: false,
			},
		},
		series: [2, 1],
	};

	return (
		<>
			<div className="comp1">
				<div className="card1">
					<div
						className="days-opt"
						style={{ display: options ? "flex" : "none" }}>
						<div className="op1">
							<h6 className="sub-op">1 Month</h6>
						</div>
						<div className="op2">
							<h6 className="sub-op">1 Year</h6>
						</div>
					</div>
					<div className="cards" id="card1">
						<div
							className="divinfo1"
							style={{ color: props.mode ? "white" : "" }}>
							<div className="card1-opt">
								<div className="card-pic1">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none">
										<path
											d="M16.7938 12.5014L15.3617 8.694C16.4238 8.80561 17.4876 8.50092 18.3298 7.844C18.5577 7.569 18.857 7.36186 19.195 7.246C19.5331 7.13016 19.8965 7.10962 20.2454 7.18708C20.6202 7.28484 20.9215 7.56275 21.0492 7.92839C21.1077 8.26209 21.3097 8.55342 21.6016 8.72525C22.2224 8.9594 22.9142 8.9123 23.4976 8.59646C23.7813 8.49891 24.3126 8.31431 24.382 8.40337C24.3057 9.89178 23.8878 11.3422 23.1608 12.6431C22.1999 12.9386 21.2012 13.0933 20.1959 13.1029L20.1945 13.1027C19.0358 13.088 17.8874 12.8848 16.7938 12.5014H16.7938ZM29.4721 27.7871C29.3484 28.8364 28.904 29.8219 28.1997 30.6095C27.4953 31.3969 26.5652 31.9479 25.5362 32.1871C21.8998 33.0831 18.1007 33.0831 14.4642 32.1871C13.4351 31.9478 12.505 31.3969 11.8006 30.6095C11.0961 29.822 10.6519 28.8365 10.5282 27.7871C9.87222 20.5071 14.9923 15.2911 16.3522 14.0431H16.352C17.5843 14.4616 18.8747 14.683 20.1761 14.6991H20.1922C21.3973 14.6893 22.5944 14.5007 23.7442 14.1391C25.2321 15.5152 30.1122 20.6351 29.4722 27.7871L29.4721 27.7871ZM20.3361 22.5871C20.3042 22.5871 20.2881 22.571 20.256 22.571C19.104 21.9951 19.2 21.675 19.2959 21.3871C19.3604 21.2094 19.4778 21.0558 19.6323 20.9471C19.7868 20.8384 19.9709 20.7797 20.16 20.7791H20.176C20.3624 20.7703 20.5472 20.8195 20.7046 20.9197C20.8622 21.0199 20.985 21.1663 21.056 21.3391C21.2225 21.7471 21.6852 21.9465 22.0959 21.7871C22.2941 21.7096 22.4528 21.5561 22.537 21.3605C22.6211 21.1652 22.6236 20.9442 22.5439 20.7472C22.27 20.0458 21.6841 19.513 20.9599 19.3072V18.6831C20.9586 18.2418 20.6012 17.8844 20.1599 17.8831C19.947 17.8811 19.7423 17.9646 19.5919 18.1152C19.4414 18.2657 19.3577 18.4704 19.3599 18.6831V19.323C18.6146 19.5675 18.0278 20.1482 17.7758 20.8911C17.1358 22.827 19.0077 23.7391 19.6157 24.027C19.6476 24.0431 19.6637 24.059 19.6956 24.059C20.8637 24.6348 21.1356 24.907 21.0235 25.3868C20.9436 25.7228 20.5275 25.8668 20.1916 25.8989H20.0795L20.0797 25.8991C19.8431 25.9217 19.605 25.8746 19.3947 25.7636C19.1844 25.6529 19.011 25.483 18.8958 25.275C18.7242 24.8699 18.2588 24.6782 17.8517 24.8444C17.4443 25.0109 17.2465 25.4737 17.4079 25.8831C17.7568 26.6924 18.4912 27.2703 19.3599 27.419V27.7391C19.3577 27.9518 19.4414 28.1565 19.5918 28.3072C19.7423 28.4576 19.947 28.5411 20.1599 28.5391C20.6012 28.5378 20.9586 28.1804 20.9599 27.7391V27.3552C21.3476 27.2625 21.7028 27.0663 21.9876 26.7873C22.2722 26.5083 22.4755 26.157 22.5757 25.771C23.0239 23.8991 21.344 23.0831 20.336 22.5871L20.3361 22.5871Z"
											fill="white"
										/>
									</svg>
								</div>
								<div className="wrap">
									<h4
										onClick={handleOptions}
										id="uk"
										className="dayz"
										style={{ color: options ? "black" : "white" }}>
										7 Days
									</h4>
									<svg
										onClick={handleOptions}
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none">
										<path
											d="M4 6L8 10L12 6"
											stroke={options ? "black" : "white"}
											strokeWidth="1.2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</div>
							</div>
							<div className="card-heading">
								<h3>Balance</h3>
							</div>
							<div className="card-subheading">
								<h1>4,590</h1>
							</div>
						</div>

						<Chart
							options={bar.options}
							series={bar.series}
							type="bar"
							width={bar.options.chart.width}
							height={bar.options.chart.height}
						/>
					</div>
				</div>
				<div className="card2">
					<div
						className="days-opt"
						style={{
							display: options1 ? "flex" : "none",
							backgroundColor: props.mode ? "#383854" : "",
							color: props.mode ? "white" : "",
						}}>
						<div className="op1">
							<h6 className="sub-op">1 Month</h6>
						</div>
						<div className="op2">
							<h6 className="sub-op">1 Year</h6>
						</div>
					</div>
					<div
						className="cards"
						id="card2"
						style={{ backgroundColor: props.mode ? "#2E2E48" : "" }}>
						<div
							className="divinfo2"
							style={{ color: props.mode ? "white" : "" }}>
							<div className="card2-opt">
								<div className="card-pic2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none">
										<path
											d="M11.1838 10.0018V17.5071C11.1838 18.8831 12.3096 20.0089 13.6856 20.0089H26.1945C27.5705 20.0089 28.6963 18.8831 28.6963 17.5071V10.0018C28.6963 8.6258 27.5705 7.5 26.1945 7.5H13.6856C12.3096 7.5 11.1838 8.6258 11.1838 10.0018ZM23.6928 11.2527H16.1874V10.0018H23.6928V11.2527Z"
											fill="#FF4F79"
										/>
										<path
											d="M32.1987 22.6358C31.9485 22.3856 31.5733 22.1354 30.8227 22.0103C30.0722 21.8852 26.0693 21.3849 25.569 21.2598C24.8185 21.1347 23.9428 21.51 22.817 22.2605C22.0665 22.7609 20.5654 23.6365 20.4403 23.6365C20.5654 23.7616 21.1909 23.7616 21.1909 23.7616H21.316C22.6919 23.7616 23.6926 24.8874 23.6926 26.1383V26.3885C23.6926 27.7645 22.5668 28.7652 21.316 28.7652H18.6891C16.4375 28.7652 14.311 26.5136 14.311 26.5136C14.311 26.5136 16.9378 27.5143 18.6891 27.5143H21.1909C21.9414 27.5143 22.4418 26.8888 22.4418 26.2634C22.4418 25.6379 21.9414 25.0125 21.316 25.0125C18.9393 24.7623 17.9385 23.7616 17.9385 23.7616C17.9385 23.7616 15.812 22.1354 15.0615 21.7601C12.4346 20.2591 7.55615 23.3863 7.55615 23.3863L10.8085 30.5165C10.8085 30.5165 12.4346 29.5157 14.6862 30.3914C16.1873 31.0168 17.0629 31.5172 18.564 32.0175C20.6905 32.7681 21.441 32.643 22.817 31.6423C24.0679 30.7666 30.0722 26.0132 30.9478 25.3878C32.1987 24.262 32.8242 23.3863 32.1987 22.6358Z"
											fill="#FF4F79"
										/>
									</svg>
								</div>
								<div className="wrap">
									<h4 className="dayz" onClick={handleOptions1}>
										7 Days
									</h4>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										onClick={handleOptions1}>
										<path
											d="M4 6L8 10L12 6"
											stroke={props.mode ? "white" : "black"}
											strokeWidth="1.2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</div>
							</div>
							<div className="card-heading">
								<h3>SMS Sent</h3>
							</div>
							<div className="card-subheading">
								<h1>2,491</h1>
							</div>
						</div>
						<Chart
							options={area.options}
							series={area.series}
							type="area"
							width={area.options.chart.width}
							height={area.options.chart.height}
						/>
					</div>
				</div>
			</div>
			<div className="comp2">
				<div className="card3">
					<div
						className="days-opt"
						style={{
							display: options2 ? "flex" : "none",
							backgroundColor: props.mode ? "#383854" : "",
							color: props.mode ? "white" : "",
						}}>
						<div className="op1">
							<h6 className="sub-op">1 Month</h6>
						</div>
						<div className="op2">
							<h6 className="sub-op">1 Year</h6>
						</div>
					</div>
					<div
						className="cards"
						id="card3"
						style={{ backgroundColor: props.mode ? "#2E2E48" : "" }}>
						<div
							className="divinfo3"
							style={{ color: props.mode ? "white" : "" }}>
							<div className="card1-opt">
								<div className="card-pic3">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none">
										<path
											d="M25.1819 17.9537L25.7883 16.3621C25.9146 16.0336 25.6619 15.6547 25.3082 15.6547H17.9314L16.3397 19.6463L16.0113 16.8421H16.2136C16.3399 16.8421 16.4663 16.7411 16.4663 16.5894V15.8314C16.4663 15.7051 16.3653 15.5787 16.2136 15.5787H14.9756C14.8493 15.5787 14.7229 15.6797 14.7229 15.8314V16.5894C14.7229 16.7157 14.8239 16.8421 14.9756 16.8421H15.2031L14.8747 19.6463L13.3084 15.7305C11.8683 16.0589 10.7315 17.2463 10.58 18.762L10.1253 23.0315C10.0747 23.461 10.3526 23.84 10.7821 23.9158C11.2368 24.0168 11.8683 24.0927 12.4999 24.1685L12.9042 30.9643C12.9294 31.5453 13.4094 31.9747 13.9904 31.9747H17.2747C17.8557 31.9747 18.3105 31.5201 18.3609 30.9643L18.9167 19.318C18.9167 18.737 19.3967 18.2822 19.9777 18.2822H24.7272C24.9293 18.2822 25.1063 18.1558 25.182 17.9537L25.1819 17.9537Z"
											fill="#FFBE0A"
										/>
										<path
											d="M19.0682 11.461C19.0682 13.3725 17.5185 14.9222 15.607 14.9222C13.6955 14.9222 12.146 13.3725 12.146 11.461C12.146 9.54953 13.6955 8 15.607 8C17.5185 8 19.0682 9.54953 19.0682 11.461Z"
											fill="#FFBE0A"
										/>
										<path
											d="M23.7418 20.0253C23.3123 19.4189 22.605 19.7979 22.605 20.2526C22.605 20.7072 22.9081 21.4652 23.2366 22.1725C23.8176 22.2483 24.4239 22.2989 25.0807 22.2989C25.7123 22.2989 26.2933 22.2483 26.8491 22.1979C27.2028 21.44 27.5313 20.6316 27.5313 20.278C27.5313 19.7473 26.8745 19.4949 26.4702 20.0506C25.9396 20.7832 25.7377 19.7222 25.1313 19.7222C24.5249 19.7222 24.1966 20.6822 23.7417 20.0253L23.7418 20.0253Z"
											fill="#FFBE0A"
										/>
										<path
											d="M26.9503 22.9305C26.3693 23.0063 25.7123 23.0569 25.0555 23.0569C24.3987 23.0569 23.7418 23.0063 23.1608 22.9305C21.7713 24.1179 20.2302 26.0884 20.2302 27.8568C20.2302 30.661 22.3777 32 25.0555 32C27.7082 32 29.8807 30.6863 29.8807 27.8568C29.8807 26.0885 28.3397 24.118 26.9502 22.9305H26.9503ZM25.4092 29.5495V30.0801C25.4092 30.1307 25.3586 30.1811 25.3082 30.1811H24.803C24.7524 30.1811 24.702 30.1305 24.702 30.0801V29.5749C24.1714 29.5497 23.7674 29.1454 23.7168 28.6148C23.7168 28.5643 23.7674 28.5139 23.8178 28.5139H24.3484C24.399 28.5139 24.4494 28.5391 24.4494 28.5896C24.4746 28.7412 24.6263 28.8675 24.803 28.8675H25.2577C25.5356 28.8675 25.7629 28.6654 25.7883 28.4129C25.8135 28.1098 25.5862 27.8571 25.2831 27.8571H24.9546C24.323 27.8571 23.742 27.3771 23.6914 26.7455C23.6157 26.0887 24.1209 25.5075 24.7525 25.4065V24.8759C24.7525 24.8253 24.8031 24.7749 24.8535 24.7749H25.3587C25.4093 24.7749 25.4597 24.8255 25.4597 24.8759V25.3811C25.9903 25.4063 26.3944 25.8106 26.4449 26.3412C26.4449 26.3918 26.3943 26.4422 26.3439 26.4422H25.8387C25.7882 26.4422 25.7378 26.417 25.7378 26.3664C25.7126 26.2148 25.5608 26.0885 25.3841 26.0885H24.9294C24.6515 26.0885 24.4242 26.2906 24.3988 26.5431C24.3736 26.8462 24.6009 27.1241 24.904 27.1241H25.2829C25.9903 27.1241 26.5713 27.7305 26.4955 28.4631C26.4197 29.019 25.9651 29.4485 25.4093 29.5495H25.4092Z"
											fill="#FFBE0A"
										/>
									</svg>
								</div>
								<div className="wrap">
									<h4 className="dayz" onClick={handleOptions2}>
										7 Days
									</h4>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										onClick={handleOptions2}>
										<path
											d="M4 6L8 10L12 6"
											stroke={props.mode ? "white" : "black"}
											strokeWidth="1.2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</div>
							</div>
							<div className="card-heading">
								<h3>Total Balance</h3>
							</div>
							<div className="card-subheading">
								<h1>6,799</h1>
							</div>
						</div>
						<Chart
							options={area1.options}
							series={area1.series}
							type="area"
							width={area1.options.chart.width}
							height={area1.options.chart.height}
						/>
					</div>
				</div>
				<div className="card4">
					<div
						className="cards"
						id="card4"
						style={{ backgroundColor: props.mode ? "#2E2E48" : "" }}>
						<div
							className="divinfo"
							style={{ color: props.mode ? "white" : "" }}>
							<div className="card-heaading">
								<h1 className="hg">Usage</h1>
								<div className="imj">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="30"
										height="39"
										viewBox="0 0 25 24"
										fill={props.mode ? "white" : "black"}>
										<path
											d="M12.5 13C13.0523 13 13.5 12.5523 13.5 12C13.5 11.4477 13.0523 11 12.5 11C11.9477 11 11.5 11.4477 11.5 12C11.5 12.5523 11.9477 13 12.5 13Z"
											stroke="#878997"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M19.5 13C20.0523 13 20.5 12.5523 20.5 12C20.5 11.4477 20.0523 11 19.5 11C18.9477 11 18.5 11.4477 18.5 12C18.5 12.5523 18.9477 13 19.5 13Z"
											stroke="#878997"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M5.5 13C6.05228 13 6.5 12.5523 6.5 12C6.5 11.4477 6.05228 11 5.5 11C4.94772 11 4.5 11.4477 4.5 12C4.5 12.5523 4.94772 13 5.5 13Z"
											stroke="#878997"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</div>
							</div>
						</div>

						<div className="ct">
							<Chart
								options={donut.options}
								series={donut.series}
								type="donut"
								height={290}
								width={290}
							/>
							<div className="inf">
								<p className="y" style={{ color: props.mode ? "white" : "" }}>
									Of 5,000
								</p>
								<p className="y" style={{ color: props.mode ? "white" : "" }}>
									SMS Used
								</p>
							</div>
							<div className="k">
								<div className="r1">
									<div className="obj1"></div>
									<p className="l" style={{ color: props.mode ? "white" : "" }}>
										Remaining
									</p>
								</div>
								<div className="r2">
									<div className="obj2"></div>
									<p className="l" style={{ color: props.mode ? "white" : "" }}>
										Used
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
